import React, {Fragment} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {RadioField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';
import {Loader, Card, Grid, Button, Popup, Icon} from 'semantic-ui-react';
import {
  onlyAllowNumbers,
  onlyTwoDecimals,
  safeSubstract,
  safeDivide,
  roundUpOrDown,
} from 'common/utils';
import {showDollarAmountWithDollar, fillArray} from 'common/utils';
import {InlineDollarFieldForm as InlineDollarField} from 'app-ui-componentlibrary';
import ReactHtmlParser from 'react-html-parser';
import REST from 'go/requests/rest';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';

export class CostShareHeader extends React.Component {
  constructor(props) {
    super(props);

    let fundingStreamType = _.get(
      this.props,
      'fundingStreamDataPath.0.fundingStreamType'
    );
    let fundingStreams = _.get(this.props, 'context.fundingOpportunityV2.fundingStream');

    let alternateCostShareQuestionDataPath = this.props.costShareQuestionDataPath;
    let defaultApplicantRates;
    _.forEach(fundingStreams, (stream) => {
      if (_.get(stream, 'fundingStreamType') === fundingStreamType) {
        defaultApplicantRates = _.get(stream, 'applicantCostShareRate');
      }
    });
    if (defaultApplicantRates === undefined) {
      defaultApplicantRates = [0.25];
    }
    const useActualPaths = _.get(this.props, 'useActualPaths');
    let costShare = _.get(this.props, 'data.share', undefined);
    let fedRates = _.get(costShare, useActualPaths ? 'actualFedRate' : 'fedRate', null);
    let fedShares = _.get(
      costShare,
      useActualPaths ? 'actualFedShare' : 'fedShare',
      null
    );
    let appShares = _.get(
      costShare,
      useActualPaths ? 'actualAppShare' : 'appShare',
      null
    );
    let appRates = _.get(costShare, useActualPaths ? 'actualAppRate' : 'appRate', null);
    this.state = {
      isAlternateCostShare: _.get(
        this.props,
        'data.' + alternateCostShareQuestionDataPath,
        'No'
      ),
      alternateCostShareQuestionDataPath,
      defaultApplicantRates,
      federalCostSharePercents:
        fedRates === null
          ? null
          : _.map(fedRates, (rate) => this.checkDecimal(rate * 100, false)),
      federalCostShareTotalAmounts: fedShares === null ? null : [...fedShares],
      nonFederalCostSharePercents:
        appRates === null
          ? null
          : _.map(appRates, (rate) => this.checkDecimal(rate * 100, true)),
      nonFederalCostShareTotalAmounts: appShares === null ? null : [...appShares],
      justification: _.get(costShare, 'justification', ''),
      isJustificationError: false,
      isJustificationRequired: false,
      isRulesLoaded: false,
    };

    const payload = {
      fundingStreamType: fundingStreamType,
      rateType: alternateCostShareQuestionDataPath,
      configType: this.props.configType,
      configId: this.props.configId,
      ruleSet: 'applicantCostShareRates',
      entityType: this.props.appEntityType,
    };
    REST.rules
      .getRulesByPayload(this.props.jwt, payload)
      .then((res) => forceJsonResponse(res, MONO))
      .then((alternateApplicantRates) => {
        this.setState({
          isRulesLoaded: true,
          alternateApplicantRates: _.get(
            _.flatMap(alternateApplicantRates),
            '[0].costShareRates'
          ),
        });
      })
      .catch((error) => console.log(error));
  }

  justificationLabel =
    'Please provide justification for exceeding the allowable federal share here.';

  isJustificationRequired = false;

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (
      !_.isEqual(this.state.alternateApplicantRates, prevState.alternateApplicantRates) ||
      !_.isEqual(this.props.totalActivityCosts, prevProps.totalActivityCosts)
    ) {
      if (
        this.state.federalCostSharePercents === null ||
        this.state.nonFederalCostSharePercents === null
      ) {
        this.calculateDefaultCostShare();
      } else {
        const totalAmountChanged =
          _.get(this.props, 'totalActivityCosts.0') ===
          _.get(prevProps, 'totalActivityCosts.0');
        this.handleNonFedShareChange(
          this.state.nonFederalCostSharePercents,
          totalAmountChanged
            ? _.get(this.state, 'nonFederalCostShareTotalAmounts.0')
            : null,
          0
        );
        this.checkForJustificationRequired(this.state.federalCostSharePercents);
      }
    } else {
      if (!_.isEqual(this.state.isAlternateCostShare, prevState.isAlternateCostShare)) {
        this.calculateDefaultCostShare();
      }
    }
  }

  calculateDefaultCostShare() {
    let applicableApplicantRates = _.isEqual(this.state.isAlternateCostShare, 'Yes')
      ? this.state.alternateApplicantRates
      : this.state.defaultApplicantRates;

    let federalCostSharePercents = _.map(
      applicableApplicantRates,
      (rate) => (1 - rate) * 100
    );
    let nonFederalCostSharePercents = _.map(
      applicableApplicantRates,
      (rate) => rate * 100
    );

    let federalCostShareTotalAmounts = _.map(
      _.get(this.props, 'totalActivityCosts', [0]),
      (totalCost, index) => totalCost * (1 - _.get(applicableApplicantRates, index))
    );
    let nonFederalCostShareTotalAmounts = _.map(
      _.get(this.props, 'totalActivityCosts', [0]),
      (totalCost, index) => totalCost * _.get(applicableApplicantRates, index)
    );

    if (!this.props.readOnly) {
      this.validateAndSaveData(
        _.map(federalCostSharePercents, (value) => this.checkDecimal(value, false)),
        _.map(federalCostShareTotalAmounts, (value) => this.checkDecimal(value, false)),
        _.map(nonFederalCostSharePercents, (value) => this.checkDecimal(value, true)),
        _.map(nonFederalCostShareTotalAmounts, (value) => this.checkDecimal(value, true))
      );
    }
  }

  handleFedShareChange = (fedSharePerc, fedShareAmt, index) => {
    if (fedSharePerc == null && fedShareAmt == null) {
      return;
    }

    if (fedSharePerc !== null) {
      fedSharePerc = this.validatePercentageFormat(fedSharePerc);
      fedShareAmt = ((fedSharePerc * this.props.totalActivityCosts[index]) / 100).toFixed(
        2
      );
    } else {
      fedSharePerc = ((fedShareAmt * 100) / this.props.totalActivityCosts[index]).toFixed(
        2
      );
    }

    var tmpval = 0;
    var nonFedSharePerc =
      (tmpval = safeSubstract(100, fedSharePerc)) < 0 ? 0 : tmpval.toFixed(2);
    var nonFedShareAmt =
      (tmpval = safeSubstract(this.props.totalActivityCosts[index], fedShareAmt)) < 0
        ? 0
        : tmpval.toFixed(2);

    var fedSharePercents = [...this.state.federalCostSharePercents];
    var fedShareAmounts = _.isEmpty(this.state.federalCostShareTotalAmounts)
      ? []
      : [...this.state.federalCostShareTotalAmounts];
    var nonFedShareAmounts = _.isEmpty(this.state.nonFederalCostShareTotalAmounts)
      ? []
      : [...this.state.nonFederalCostShareTotalAmounts];
    var nonFedSharePercents = [...this.state.nonFederalCostSharePercents];

    fedSharePercents[index] = fedSharePerc;
    fedShareAmounts[index] = fedShareAmt;
    nonFedSharePercents[index] = nonFedSharePerc;
    nonFedShareAmounts[index] = nonFedShareAmt;

    this.validateAndSaveData(
      fedSharePercents,
      fedShareAmounts,
      nonFedSharePercents,
      nonFedShareAmounts
    );
  };

  handleNonFedShareChange = (nonFedSharePerc, nonFedShareAmt, index) => {
    if (nonFedSharePerc == null && nonFedShareAmt == null) {
      return;
    }
    if (nonFedShareAmt !== null && nonFedShareAmt !== undefined) {
      nonFedSharePerc = (
        (nonFedShareAmt * 100) /
        this.props.totalActivityCosts[index]
      ).toFixed(2);
    } else if (nonFedSharePerc !== null) {
      nonFedSharePerc = this.validatePercentageFormat(nonFedSharePerc);
      nonFedShareAmt = roundUpOrDown(
        'ceil',
        (nonFedSharePerc * this.props.totalActivityCosts[index]) / 100,
        2
      ).toString();
    }

    var tmpval = 0;
    var fedSharePerc =
      (tmpval = safeSubstract(100, nonFedSharePerc)) < 0 ? 0 : tmpval.toFixed(2);
    var fedShareAmt =
      (tmpval = safeSubstract(this.props.totalActivityCosts[index], nonFedShareAmt)) < 0
        ? 0
        : tmpval.toFixed(2);

    var fedSharePercents = [...this.state.federalCostSharePercents];
    var fedShareAmounts = _.isEmpty(this.state.federalCostShareTotalAmounts)
      ? []
      : [...this.state.federalCostShareTotalAmounts];
    var nonFedShareAmounts = _.isEmpty(this.state.nonFederalCostShareTotalAmounts)
      ? []
      : [...this.state.nonFederalCostShareTotalAmounts];
    var nonFedSharePercents = [...this.state.nonFederalCostSharePercents];

    fedSharePercents[index] = fedSharePerc;
    fedShareAmounts[index] = fedShareAmt;
    nonFedSharePercents[index] = nonFedSharePerc;
    nonFedShareAmounts[index] = nonFedShareAmt;

    this.validateAndSaveData(
      fedSharePercents,
      fedShareAmounts,
      nonFedSharePercents,
      nonFedShareAmounts
    );
  };

  handleJustificationOnBlur = () => {
    this.props.saveEntityData(
      this.props.entityDataPath + '.share.justification',
      this.props.entityType,
      this.state.justification,
      'costShareHeader_justification',
      null,
      this.props.entityTypeReduxPath
    );
  };

  checkForJustificationRequired = (fedSharePercents) => {
    let isJustificationRequired = false;
    _.map(fedSharePercents, (percent, index) => {
      if (_.isEqual(this.state.isAlternateCostShare, 'Yes')) {
        isJustificationRequired =
          percent > (1 - this.state.alternateApplicantRates[index]) * 100 ? true : false;
      } else {
        isJustificationRequired =
          percent > (1 - this.state.defaultApplicantRates[index]) * 100 ? true : false;
      }
    });

    this.setState({isJustificationRequired});

    if (!isJustificationRequired) {
      this.setState({justification: ''});
    }
  };

  getErrorObject = (field) => {
    let Error = {
      isValid: true,
      message: '',
    };
    const {validationErrors, validationDirtyMap, validationErrorPath} = this.props;

    if (validationErrorPath) {
      field = `${validationErrorPath}.${field}`;
    }

    if (_.isEqual(field, 'costShareHeader_justification')) {
      const isDirty = _.get(validationDirtyMap, 'costShareHeader_justification');
      if (this.state.isAlternateCostShare === 'Yes') {
        Error = isDirty
          ? _.get(validationErrors.errors, 'costShareHeader_justification.0')
          : Error;
      } else {
        Error = isDirty
          ? _.get(validationErrors.errors, 'costShareHeader_justification.1')
          : Error;
      }
    } else {
      Error = _.get(validationErrors.errors, field + '.0', Error);
    }

    if (
      _.isEqual(field, 'costShareHeader_justification') &&
      this.state.justification.length < 1
    ) {
      Error = _.get(validationErrors.errors, 'costShareHeader_justification');
    }

    return Error;
  };

  validatePercentageFormat = (value, prevValue) => {
    if (typeof value !== 'undefined' && value !== null) {
      value = onlyAllowNumbers(value);
      // strip hyphens (allowed as numbers)
      value = value.replace(/-/g, '');
      value = onlyTwoDecimals(value);
    }
    return value;
  };

  validateAndSaveData(
    fedSharePercents,
    fedShareAmounts,
    nonFedSharePercents,
    nonFedShareAmounts
  ) {
    this.checkForJustificationRequired(fedSharePercents);

    this.setState({
      federalCostSharePercents: fedSharePercents,
      federalCostShareTotalAmounts: fedShareAmounts,
      nonFederalCostSharePercents: nonFedSharePercents,
      nonFederalCostShareTotalAmounts: nonFedShareAmounts,
    });
    if (!this.props.readOnly) {
      this.saveData(
        fedSharePercents,
        nonFedSharePercents,
        fedShareAmounts,
        nonFedShareAmounts
      );
    }
    this.props.updateNonFedShare(nonFedShareAmounts);
  }

  isWithinPercentageLimits = (value) => {
    return value < 0 || value > 100 ? false : true;
  };

  // Limits to 2 decimals. Adds .00 if no decimal
  checkDecimal = (value, isRoundUp) => {
    if (value !== undefined && value !== null) {
      value = roundUpOrDown(isRoundUp ? 'ceil' : 'floor', parseFloat(value), 2);
    }
    return value;
  };

  saveData = (
    federalCostSharePercents,
    nonFederalCostSharePercents,
    federalCostShareTotalAmounts,
    nonFederalCostShareTotalAmounts
  ) => {
    const {entityType, entityDataPath, useActualPaths} = this.props;
    this.props.saveEntityData(
      entityDataPath + (useActualPaths ? '.share.actualFedRate' : '.share.fedRate'),
      entityType,
      _.map(federalCostSharePercents, (item) => {
        return roundUpOrDown('floor', safeDivide(item, 100), 4).toString();
      }),
      false,
      null,
      this.props.entityTypeReduxPath
    );

    this.props.saveEntityData(
      entityDataPath + (useActualPaths ? '.share.actualAppRate' : '.share.appRate'),
      entityType,
      _.map(nonFederalCostSharePercents, (item) => {
        return roundUpOrDown('ceil', safeDivide(item, 100), 4).toString();
      }),
      false,
      null,
      this.props.entityTypeReduxPath
    );

    this.props.saveEntityData(
      entityDataPath + (useActualPaths ? '.share.actualFedShare' : '.share.fedShare'),
      entityType,
      fillArray(federalCostShareTotalAmounts, '0.00'),
      false,
      null,
      this.props.entityTypeReduxPath
    );

    this.props.saveEntityData(
      entityDataPath + (useActualPaths ? '.share.actualAppShare' : '.share.appShare'),
      entityType,
      fillArray(nonFederalCostShareTotalAmounts, '0.00'),
      false,
      null,
      this.props.entityTypeReduxPath
    );

    this.props.saveEntityData(
      entityDataPath + '.' + this.state.alternateCostShareQuestionDataPath,
      entityType,
      this.state.isAlternateCostShare,
      false,
      null,
      this.props.entityTypeReduxPath
    );

    this.props.saveEntityData(
      entityDataPath + '.share.justification',
      entityType,
      this.state.justification,
      false,
      null,
      this.props.entityTypeReduxPath
    );
  };

  handleAlternateCostShareChange(e) {
    this.setState({
      isAlternateCostShare: _.get(e, 'target.value'),
    });
  }

  getImpoverishedToolTipContent() {
    return (
      <Grid centered divided columns={1}>
        <Grid.Column>
          <div>
            <br />
            <strong>Small impoverished community</strong>
            <br />
            <br />
            <p>
              A Small and Impoverished Community must meet all of the following criteria:
            </p>
            <ul>
              <li>
                It must be economically disadvantaged, with residents having an average
                per capita annual income not exceeding 80 percent of national per capita
                income based on best available data. It must meet any other factors
                identified in the mitigation plan in which the community is located.
              </li>
              <li>
                If Yes is selected, the default Federal Share and Non-Federal Share 
                percentage (75%/25%) changes to 90%/10%. If No is selected, the default
                value of Federal Share Percentage and Non-Federal Percentage is retained.
              </li>
              <li>
                It must have a local unemployment rate that exceeds by one percentage
                point or more, the most recently reported, average yearly national
                unemployment rate; and
              </li>
              <li>
                It must be a community of 3,000 or fewer individuals that are identified
                by the State as a rural community and is not a remote area within the
                corporate boundaries of a larger city.
              </li>
            </ul>
          </div>
        </Grid.Column>
      </Grid>
    );
  }

  getAlternateCostShareQuestion() {
    return (
      <Fragment>
        <a color="blue" className={`budget-cs-font-size`}>
          <Popup
            hideOnScroll
            on={['click', 'focus', 'hover']}
            position="bottom left"
            wide="very"
            content={
              <Grid centered divided columns={1}>
                <Grid.Column>
                  <div>
                    <strong>Small Impoverished Community</strong> <br />
                    <br />
                    <p>
                      1. Small, impoverished communities are eligible for up to 90 percent
                      federal cost share for their capability and capacity building and
                      mitigation project subapplications in accordance with the Stafford
                      Act. A small impoverished community must:
                    </p>
                    <ul>
                      <li>
                        Be a community of 3,000 or fewer individuals identified by the
                        Applicant; and
                      </li>
                      <li>
                        Be economically disadvantaged, with residents having an average
                        per capita annual income not exceeding 80 percent of national per
                        capita income, based on best available data.
                      </li>
                    </ul>
                    <p>2. Additional Information & Requirements:</p>
                    <ul>
                      <li>
                        If Yes is selected, you must attach documentation to demonstrate
                        Small Impoverished Community for this subapplication.
                      </li>
                      <li>
                        Federal Share percentage: If Yes is selected, the default Federal
                        Share and Non-Federal Share percentage (75%/25%) changes to
                        90%/10%. If No is selected the default value of Federal Share
                        Percentage and Non-Federal Percentage is retained.
                      </li>
                    </ul>
                  </div>
                </Grid.Column>
              </Grid>
            }
            trigger={
              <div tabIndex={0}>
                <strong>{'Is this a small impoverished community? '}</strong>
                <Icon
                  name="info circle"
                  color="blue"
                  label="Small impoverished community"
                  title="Small impoverished community"
                />
              </div>
            }
          />
        </a>
        This determines your federal/non-federal share ratio. <br />
      </Fragment>
    );
  }

  getAlternateCostShareQuestionFromConfig() {
    const {alternateQuestion} = this.props;
    const alternateQuestionText = _.get(alternateQuestion, 'question');
    const explanation = _.get(alternateQuestion, 'explanation');
    const explanationLabel = _.get(alternateQuestion, 'explanationLabel');

    return (
      <Fragment>
        <a color="blue" className={`budget-cs-font-size`}>
          <Popup
            hideOnScroll
            on={['click', 'focus', 'hover']}
            position="bottom left"
            wide="very"
            content={
              <Grid centered divided columns={1}>
                <Grid.Column>{ReactHtmlParser(explanation)}</Grid.Column>
              </Grid>
            }
            trigger={
              <div tabIndex={0}>
                <strong>{`${alternateQuestionText} `}</strong>
                <Icon
                  name="info circle"
                  color="blue"
                  label={explanationLabel}
                  title={explanationLabel}
                />
              </div>
            }
          />
        </a>
        This determines your federal/non-federal share ratio. <br />
      </Fragment>
    );
  }

  render() {
    const {
      totalActivityCosts,
      isLoaded,
      alternateQuestion,
      readOnly = false,
    } = this.props;
    const fedPercentError = this.getErrorObject('costShareHeader_fedSharePercent0');
    const nonFedPercentError = this.getErrorObject('costShareHeader_nonFedSharePercent0');
    return isLoaded && this.state.isRulesLoaded ? (
      <React.Fragment>
        {ReactHtmlParser(this.props.costShareInstructionalText)}
        <Card fluid className={`budget-cs-background-color`}>
          <Grid>
            <Grid.Row className={`shares noTopPadding budget-cs-padding-left`}>
              <Grid.Column width={5} className="left-side">
                {!_.isEmpty(alternateQuestion)
                  ? this.getAlternateCostShareQuestionFromConfig()
                  : this.getAlternateCostShareQuestion()}
                {!readOnly ? (
                  <RadioField
                    name="alternate costshare"
                    id="alternate-costshare"
                    value={this.state.isAlternateCostShare}
                    options={[
                      {label: 'Yes', value: 'Yes'},
                      {label: 'No', value: 'No'},
                    ]}
                    handleChange={(e) => this.handleAlternateCostShareChange(e)}
                  />
                ) : (
                  this.state.isAlternateCostShare
                )}
              </Grid.Column>
              <Grid.Column
                width={10}
                className={`right-side budget-cs-padding-bottom budget-cs-padding-top--double`}
              >
                <Grid>
                  <Grid.Row className={`noBottomPadding`}>
                    <Grid columns={4}>
                      <Grid.Column width={3} className={`noBottomPadding`} />
                      <Grid.Column width={5} className={`noBottomPadding`} />
                      <Grid.Column
                        width={3}
                        className={`noPadding budget-cs-padding-right`}
                      >
                        <span className={`budget-cs-smaller-font-size`}>
                          <strong>% Percentage</strong>
                        </span>
                      </Grid.Column>
                      <Grid.Column width={4} className={`noPadding`}>
                        <span className={`budget-cs-smaller-font-size`}>
                          <strong>$ Dollar amount</strong>
                        </span>
                      </Grid.Column>
                    </Grid>
                  </Grid.Row>
                  <Grid.Row className={`noTopPadding noBottomPadding`}>
                    <Grid columns={4}>
                      <Grid.Column width={3} className={`noBottomPadding`} />
                      <Grid.Column width={5} className={`budget-cs-padding-top`}>
                        <strong>Proposed federal share</strong>
                      </Grid.Column>
                      <Grid.Column
                        width={3}
                        className={`budget-cs-padding-top  budget-cs-padding-right`}
                      >
                        <div
                          className={!fedPercentError.isValid ? 'errorBorderLine' : ''}
                        >
                          <strong
                            id="federalSharePerc"
                            className={!fedPercentError.isValid ? 'errorFieldBorder' : ''}
                          >
                            {_.get(this.state, 'federalCostSharePercents.0')}
                          </strong>
                          {!fedPercentError.isValid && (
                            <div className={`errorMessages`}>
                              {fedPercentError.message}
                            </div>
                          )}
                        </div>
                      </Grid.Column>
                      <Grid.Column
                        width={4}
                        className={`noPadding ${
                          readOnly ? 'budget-cs-padding-top budget-cs-padding-right' : ''
                        } `}
                      >
                        {!readOnly ? (
                          <InlineDollarField
                            size="default"
                            id="federalShareDollar"
                            name="federalShareDollar"
                            value={_.get(this.state, 'federalCostShareTotalAmounts.0')}
                            handleChange={(name, value) => {
                              this.handleFedShareChange(null, value, 0);
                            }}
                            handleBlur={() => {}}
                            displayError={
                              !this.getErrorObject('costShareHeader_fedShareAmount0')
                                .isValid
                            }
                            errorMessages={
                              this.getErrorObject('costShareHeader_fedShareAmount0')
                                .message
                            }
                          />
                        ) : (
                          <strong>
                            {_.get(this.state, 'federalCostShareTotalAmounts.0')}
                          </strong>
                        )}
                      </Grid.Column>
                    </Grid>
                  </Grid.Row>
                  <Grid.Row className={`noTopPadding noBottomPadding`}>
                    <Grid columns={4}>
                      <Grid.Column width={3} className={`noBottomPadding`} />
                      <Grid.Column
                        width={5}
                        className={`budget-cs-padding-top noBottomPadding`}
                      >
                        <strong>Proposed non-federal share</strong>
                      </Grid.Column>
                      <Grid.Column
                        width={3}
                        className={`budget-cs-padding-top noBottomPadding budget-cs-padding-right`}
                      >
                        <div
                          className={!nonFedPercentError.isValid ? 'errorBorderLine' : ''}
                        >
                          <strong
                            id="nonFederalSharePerc"
                            className={
                              !nonFedPercentError.isValid ? 'errorFieldBorder' : ''
                            }
                          >
                            {_.get(this.state, 'nonFederalCostSharePercents.0')}
                          </strong>
                          {!nonFedPercentError.isValid && (
                            <div className={`errorMessages`}>
                              {nonFedPercentError.message}
                            </div>
                          )}
                        </div>
                      </Grid.Column>
                      <Grid.Column
                        width={4}
                        className={`noPadding ${
                          readOnly ? 'budget-cs-padding-top budget-cs-padding-right' : ''
                        } `}
                      >
                        {!readOnly ? (
                          <InlineDollarField
                            size="default"
                            id="nonFederalShareDollar"
                            name="nonFederalShareDollar"
                            value={_.get(this.state, 'nonFederalCostShareTotalAmounts.0')}
                            handleChange={(name, value) => {
                              this.handleNonFedShareChange(null, value, 0);
                            }}
                            handleBlur={() => {}}
                            displayError={
                              !this.getErrorObject('costShareHeader_nonFedShareAmount0')
                                .isValid
                            }
                            errorMessages={
                              this.getErrorObject('costShareHeader_nonFedShareAmount0')
                                .message
                            }
                          />
                        ) : (
                          <strong>
                            {_.get(this.state, 'nonFederalCostShareTotalAmounts.0')}
                          </strong>
                        )}
                      </Grid.Column>
                    </Grid>
                  </Grid.Row>
                  <Grid.Row className={`noTopPadding`}>
                    <Grid columns={4}>
                      <Grid.Column width={3} className={`noBottomPadding`} />
                      <Grid.Column width={5} className={`noTopPadding`} />
                      <Grid.Column
                        width={3}
                        className={`noPadding budget-cs-padding-right`}
                      />
                      <Grid.Column width={4} className={`noPadding`}>
                        <div className={`text-align-right budget-cs-smaller-font-size`}>
                          <strong>
                            Based on total budget cost:{' '}
                            {showDollarAmountWithDollar(totalActivityCosts[0])}
                          </strong>
                        </div>
                      </Grid.Column>
                    </Grid>
                  </Grid.Row>
                  {this.state.isJustificationRequired && (
                    <Grid.Row>
                      <Grid.Column width={13} className={`noTopPadding`}>
                        <span className={`budget-cs-justification-color`}>
                          <strong>{this.justificationLabel}</strong>
                        </span>
                        {!readOnly ? (
                          <TextAreaField
                            rows={4}
                            maxLength={4001}
                            title="Justification"
                            label=""
                            id="justification"
                            name="justification"
                            value={this.state.justification}
                            handleChange={(e, data) =>
                              this.setState({justification: data.value})
                            }
                            handleBlur={this.handleJustificationOnBlur}
                            displayError={
                              !this.getErrorObject('costShareHeader_justification')
                                .isValid
                            }
                            errorMessages={
                              this.getErrorObject('costShareHeader_justification').message
                            }
                          />
                        ) : (
                          <Fragment>
                            <br /> <br />
                            {this.state.justification}
                          </Fragment>
                        )}
                      </Grid.Column>
                    </Grid.Row>
                  )}
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              {ReactHtmlParser(this.props.fundingSourcesInstructionalText)}
              {this.props.appEntityType === 'subAwardRecommendation'
                ? readOnly
                : !readOnly && (
                    <Button
                      className="pull-right"
                      id="add-cost-share-item"
                      primary
                      basic
                      as="a"
                      href="#"
                      onClick={this.props.openModal}
                    >
                      + Add funding source
                    </Button>
                  )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    ) : (
      <Loader inline="centered" active>
        Loading...
      </Loader>
    );
  }
}

export const mapStateToProps = (state) => ({
  dynamicComponent: state.dynamicComponent,
  context: state.dynamicComponent.context,
  jwt: state.auth.token,
});

export default connect(mapStateToProps, null)(connectDynamic(CostShareHeader));
